import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import AppBrand from '../../../components/AppBrand';
import { PhoneIcon } from '../../icons/redesignIcons';

import './MoVeInDesktopHeader.css';

@withRouter
@inject('translationsStore', 'moveinStore')
@observer
export default class MoVeInDesktopHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      supportInTollFreeVersion: true
    };
  }

  componentDidMount = () => {
    this.timeoutCheckSupportVersion = setTimeout(this.toggleSupportVersionFn, 5000);
  };

  componentWillUnmount = () => {
    clearInterval(this.timeoutCheckSupportVersion);
  };

  toggleSupportVersionFn = () => {
    this.setState({ supportInTollFreeVersion: !this.state.supportInTollFreeVersion }, () => {
      const timeout = this.state.supportInTollFreeVersion ? 5000 : 15000;
      this.timeoutCheckSupportVersion = setTimeout(this.toggleSupportVersionFn, timeout);
    });
  };

  onSupportClick = () => {
    const { supportInTollFreeVersion } = this.state;
    const url = supportInTollFreeVersion ? 'tel:800101222' : 'tel:+393459782557';
    window.open(url, '_blank');
    return null;
  };

  render() {
    const { translationsStore } = this.props;
    const { supportInTollFreeVersion } = this.state;

    const cls = classNames({
      MoVeInDesktopHeader: true,
      [this.props.className]: !!this.props.className
    });

    return (
      <div className={cls}>
        <AppBrand style={{ color: 'var(--action-brand-color)', fontSize: 64 }} />
        <div className="HeaderSupport" onClick={this.onSupportClick}>
          <PhoneIcon />
          {supportInTollFreeVersion ? (
            <span>
              {translationsStore.translate('movein.header.tollFreeLabel')} <b>{translationsStore.translate('movein.header.tollFreeNumber')}</b>
            </span>
          ) : (
            <span>
              {translationsStore.translate('movein.header.mobileLabel')} <b>{translationsStore.translate('movein.header.mobileNumber')}</b>
            </span>
          )}
        </div>
      </div>
    );
  }
}
